import axios from "axios";
import moment from "moment";
import { API_URL, API_URL_ESV } from "../utils/Constant";
// import { getViewAsPerStatusCode } from "../../../../utils/helpers";

export const getCustomers = async () => {
  try {
    const response = await axios.get(`${API_URL}/companynames/?`);
    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    const message = "Something went wrong. getCustomers()";
    return { success: false, message };
  }
};

// get samples data for one work order
// http://127.0.0.1:5000/api/getwodata/?
// wo=021821_18
export const getData = async (payload) => {
  try {
    const response = await axios.get(`${API_URL}/getwodata/`, {
      params: {
        wo: payload.wo || "",
        report_id: payload.reportID || "",
      },
    });
    const data = await response.data;
    const res = { samples: [], ctg: "" };
    if (data && data.length > 0) {
      const result = data[0].result;
      if (result && result.length > 0) {
        for (let i = 0; i < result.length; i++) {
          // change the date format for the post request
          if (result[i].report_date.includes("/")) {
            // const reportDateArr = result[i].report_date.split("/");
            // const formattedReportDate =
            //   reportDateArr[2] +
            //   "-" +
            //   reportDateArr[0] +
            //   "-" +
            //   reportDateArr[1] +
            //   " 0:0";
            // result[i].report_date = formattedReportDate;
            result[i].report_date = `${moment(Date.now()).format("YYYY-MM-DD")} 0:0`;
          } else {
            // result[i].report_date = result[i].report_date + " 0:0";
            result[i].report_date = `${moment(Date.now()).format("YYYY-MM-DD")} 0:0`;
          }
          if (result[i].received_date.includes("/")) {
            const receivedDateArr = result[i].received_date.split("/");
            const formattedReceivedDate = `${receivedDateArr[2]}-${receivedDateArr[0]}-${receivedDateArr[1]} 0:0`;
            result[i].received_date = formattedReceivedDate;
          } else {
            result[i].received_date = `${result[i].received_date} 0:0`;
          }
        }

        // set ctg for the post request
        const test = result[0].test_list[0].Result;
        if (
          test.endsWith("g")
          || test.endsWith("ml")
          || test.includes("ppb")
          || test.includes("ppm")
          || test.includes("pesticides")
        ) {
          res.ctg = "product";
        } else {
          res.ctg = "env";
        }
        res.samples = result;
      }
    }

    // console.log("==== getData res", res);
    return { success: true, ...res };
  } catch (e) {
    console.log("error from getData", e);
    // getViewAsPerStatusCode(e);
    const message = "Something went wrong.";
    return { success: false, message };
  }
};

// post request to save the sample and report path to DB
// ngrok url
export const saveData = async (payload) => {
  // console.log(" ESV Payload:", payload)
  try {
    if (payload.ctg === "env") {
      // console.log("==== saveData env payload.data", payload.data);
      const response = await axios.post(
        `${API_URL_ESV}/environment_report/`,
        payload.data,
      );
      const data = await response.data;
      // console.log("==== saveData env data", data);
      return { success: true, ...data };
    }
    const response = await axios.post(
      `${API_URL_ESV}/product_report/`,
      payload.data,
    );
    const data = await response.data;
    // console.log("==== saveData  prod data", data);
    return { success: true, ...data };

    // else if (payload.ctg === "product") {
    //   let response = await axios.post(
    //     `${API_URL_ESV}/product_report/`,
    //     payload.data
    //   );
    //   let data = await response.data;
    //   // console.log("==== saveData  prod data", data);
    //   return { success: true, ...data };
    // }
  } catch (e) {
    console.log("error from saveData", e);
    // getViewAsPerStatusCode(e);
    const message = "Something went wrong.";
    return { success: false, message };
  }
};

// export const sendS3Url = async (payload) => {
//   try {
//     let response = await axios.get(`${API_URL}/sendreports/`, {
//       params: {
//         order_id: "062921_400" || payload.id,
//         s3_url: payload.url || "010621_220D0107R58-WawonaFrozenFoods.pdf",
//       },
//     });
//     let data = await response.data;
//     return { success: true, ...data };
//   } catch (e) {
//     return { success: false };
//   }
// };

// email
export const sendS3UrlGrouped = async (payload) => {
  const params = {
    title: "send",
    list: payload,
  };
  try {
    const response = await axios.post(`${API_URL}/sendreports/`, params);
    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    return { success: false };
  }
};
